import {
  UPDATED_GLOBAL_ERROR_MESSAGE,
  REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING
} from "../actions/globalError";
import { UPDATED_GLOBAL_SUCCESS_MESSAGE } from "../actions/globalSuccess";

import objectAssign from "object-assign";

import { globalErrorInitialState } from "../state/initialState";

function globalErrorReducer(state = globalErrorInitialState, action) {
  let newStatus;
  switch (action.type) {
    case UPDATED_GLOBAL_SUCCESS_MESSAGE:
      newStatus = {
        message: ""
      };
      return objectAssign({}, state, newStatus);
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        message: action.data.message || action.data
      };
      return objectAssign({}, state, newStatus);
    case REMOVE_GLOBAL_ERROR_MESSAGE_IF_MATCHES_THIS_STRING:
      if (
        state.message == action.data ||
        (action.data &&
          state.message.toLowerCase().includes(action.data.toLowerCase()))
      ) {
        newStatus = {
          message: ""
        };
      } else {
        newStatus = {};
      }

      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
}

export default globalErrorReducer;
